﻿import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AlertService, AuthenticationService } from '../_services';

import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { LoginUser } from './../store/actions/appActions';
import { environment } from './../../environments/environment';

@Component({ templateUrl: 'login.component.html' })
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    userId: number;
    access_token: string;
    league_type: string;
    draftID: string;
    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private store: Store<AppState>
    ) { }

    ngOnInit() {  
        if (typeof this.route.snapshot.queryParams['token'] !== 'undefined') {
            this.access_token = this.route.snapshot.queryParams['token'];

            this.league_type = this.route.snapshot.queryParams['league_type'];
            this.draftID = this.route.snapshot.queryParams['league_code'];
            let tournament = '';
            let round_no = '';
            let tour_league_id = '';
            if (typeof this.route.snapshot.queryParams['tournament'] !== 'undefined') {
                tournament = this.route.snapshot.queryParams['tournament'];
                round_no = this.route.snapshot.queryParams['round_no'];
                tour_league_id = this.route.snapshot.queryParams['league_id'];
            }   
            this.submitted = false;
            this.loading = true;
            this.authenticationService.login_token(this.access_token)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.message === 'Access granted') { 
                            this.store.dispatch(new LoginUser(
                                {
                                    user_id: data.data.data.id,
                                    user_name: data.data.data.username,
                                    drafters_id: data.data.data.drafters_id
                                }
                            ));
                            if(tournament && (tournament ===  `${environment.tournament}`)){
                                this.router.navigate(['/resultboard/draft/players/' + this.league_type + '/' + this.draftID+ '/' + tournament+ '/' + round_no+ '/' + tour_league_id]);
                            }else{
                                this.router.navigate(['/resultboard/draft/players/' + this.league_type + '/' + this.draftID]);
                            }
                        } else {
                            window.location.href    =   `${environment.SITE_URL}`;
                            //this.router.navigate([`${environment.SITE_URL}`]);
                        }
                    },
                    error => {
                        window.location.href = `${environment.SITE_URL}`;
                        this.alertService.error(error);
                        this.loading = false;
                    });

        } else {
            window.location.href = `${environment.SITE_URL}`;
        }

        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        // reset login status
        this.authenticationService.logout();


        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.router.navigate(['/']);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }



}
